"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WS_TIMEOUT = 30000;
exports.WS_TIMEOUT = WS_TIMEOUT;
//# sourceMappingURL=defaults.js.map


//////////////////
// WEBPACK FOOTER
// ./~/subscriptions-transport-ws/dist/defaults.js
// module id = 768
// module chunks = 0